"use strict";
/*
 * Copyright 2020 - MATTR Limited
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *     http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Bls12381G1Jwk_1 = require("./Bls12381G1Jwk");
exports.assertBls12381G1PrivateJwk = Bls12381G1Jwk_1.assertBls12381G1PrivateJwk;
exports.assertBls12381G1PublicJwk = Bls12381G1Jwk_1.assertBls12381G1PublicJwk;
var Bls12381G2Jwk_1 = require("./Bls12381G2Jwk");
exports.assertBls12381G2PrivateJwk = Bls12381G2Jwk_1.assertBls12381G2PrivateJwk;
exports.assertBls12381G2PublicJwk = Bls12381G2Jwk_1.assertBls12381G2PublicJwk;
//# sourceMappingURL=index.js.map